import { thunkGetAppConfig } from 'app/appSlice';
import { AgencyConstants } from 'features/Agency/agencyHelper';
import KT01BaseLayout from 'general/components/BaseLayout/KT01BaseLayout';
import KTFormInput, {
  KTFormInputType,
} from 'general/components/OtherKeenComponents/Forms/KTFormInput';
import KTTooltip from 'general/components/OtherKeenComponents/KTTooltip';
import AppColors from 'general/constants/AppColors';
import miscHelper from 'general/helpers/miscHelper';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import useAppConfig from 'hooks/useAppConfig';
import useWindowSize from 'hooks/useWindowSize';
import _ from 'lodash';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

function AgencyConfigCommissionScreen(props) {
  // MARK: ---- PROPERTIES ----
  const dispatch = useDispatch();
  const [editMode, setEditMode] = useState(false);
  const [commissionRateSale, setCommissionRateSale] = useState(0);
  const [commissionRateGroup, setCommissionRateGroup] = useState(0);
  const [commissionRateChargePoint, setCommissionRateChargePoint] = useState(0);
  const [commissionGrounds, setCommissionGrounds] = useState([]);
  const appConfig = useAppConfig();
  useEffect(() => {
    setCommissionRateSale(Number((appConfig.commissionRateSale * 100).toFixed(0)));
    setCommissionRateGroup(Number((appConfig.commissionRateGroup * 100).toFixed(0)));
    setCommissionRateChargePoint(Number((appConfig.commissionRateChargePoint * 100).toFixed(0)));

    setCommissionGrounds(
      appConfig.commissionRateLandlord
        ? JSON.parse(appConfig.commissionRateLandlord)
          .map(item => ({
            key: item.key,
            name: item.name,
            value: item?.value ?? 0,
            car: item?.car ?? 0,
            bike: item?.bike ?? 0,
            show: item.show
          }))
        : [{ name: '', value: 0, car: 0, bike: 0 }]
    );
  }, [appConfig]);
  const [loading, setLoading] = useState(false);

  // MARK: ---- FUNCTIONS ----
  const handleSave = async () => {
    // validate du lieu
    if (parseInt(commissionRateSale) < 0 || parseInt(commissionRateSale) > 100) {
      ToastHelper.showError('Tỷ lệ hoa hồng bán nhượng quyền không hợp lệ');
      return;
    }
    if (parseInt(commissionRateGroup) < 0 || parseInt(commissionRateGroup) > 100) {
      ToastHelper.showError('Tỷ lệ hoa hồng bán gói đầu tư HTKD không hợp lệ');
      return;
    }
    if (parseInt(commissionRateChargePoint) < 0 || parseInt(commissionRateChargePoint) > 100) {
      ToastHelper.showError('Tỷ lệ hoa hồng bán trụ sạc không hợp lệ');
      return;
    }
    const hasInvalidGround = commissionGrounds.some(
      item => !item.show && item.value <= 0 || item.show && (item.car <= 0 || item.bike <= 0)
    );
    if (hasInvalidGround) {
      ToastHelper.showError('Mức hoa hồng giới thiệu mặt bằng phải lớn hơn 0');
      return;
    }
    const filteredCommissionGrounds = commissionGrounds.filter((item) => item.name !== '');

    // ty he hoa hong ban nhuong quyen
    const paramCommissionRateSale = {
      key: AgencyConstants.ConfigKey.COMMISSION_RATE_SALE,
      value: parseInt(commissionRateSale) / 100,
    };
    // ty le hoa hong ban goi dau tu HTKD
    const paramCommissionRateGroup = {
      key: AgencyConstants.ConfigKey.COMMISSION_RATE_GROUP,
      value: parseInt(commissionRateGroup) / 100,
    };
    // ty le hoa hong ban tru sac
    const paramCommissionRateChargePoint = {
      key: AgencyConstants.ConfigKey.COMMISSION_RATE_CHARGEPOINT,
      value: parseInt(commissionRateChargePoint) / 100,
    };
    // ty le hoa hong gioi thieu mat bang
    const paramCommissionLandlord = {
      key: AgencyConstants.ConfigKey.COMMISSION_RATE_LANDLORD,
      value: JSON.stringify(
        filteredCommissionGrounds?.map((item, index) => {
          const result = {
            key: item.key ?? `loai_${index + 1}`,
            name: item.name,
            show: item.show,
          };

          const value = !item.show ? parseInt(item.value) : 0;
          const car = item.show ? parseInt(item.car) : 0;
          const bike = item.show ? parseInt(item.bike) : 0;

          if (!item?.show) result.value = value;
          if (item?.show) result.car = car;
          if (item?.show) result.bike = bike;

          return result;
        }) || []
      ),
    };
    setLoading(true);
    try {
      await miscHelper.callApiUpdateConfig(paramCommissionRateSale);
      await miscHelper.callApiUpdateConfig(paramCommissionRateGroup);
      await miscHelper.callApiUpdateConfig(paramCommissionRateChargePoint);
      await miscHelper.callApiUpdateConfig(paramCommissionLandlord);
    } catch (error) { }

    setLoading(false);
    ToastHelper.showSuccess('Lưu cấu hình hoa hồng thành công');
    setEditMode(false);
    dispatch(thunkGetAppConfig());
  };

  const handleCancel = () => {
    setEditMode(false);
    dispatch(thunkGetAppConfig());
  };

  return (
    <KT01BaseLayout isFullScreen={true}>
      <div className="container-fluid p-4">
        {UIHelper.buildCard(
          <div className="px-4 pt-4">
            {/* header */}
            <div className="d-flex align-items-center justify-content-between">
              <span style={UIHelper.buildFontStyle('600', '18px', AppColors.gray[800])}>
                Cấu hình hoa hồng
              </span>
              {editMode && (
                <div className='d-flex gap-3'>
                  {UIHelper.buildNegativeButton('Hủy bỏ', handleCancel, null)}
                  {UIHelper.buildGreenButton('Lưu thay đổi', handleSave, null, false, loading)}
                </div>
              )}
              {!editMode && UIHelper.buildBlueButton('Chỉnh sửa', () => setEditMode(true), null)}
            </div>
            {/* body */}
            <div>
              {/* hoa hong ban goi dau tu HTKD */}
              <div
                className="py-2"
                style={{
                  borderBottom: `1px dashed ${AppColors.gray[300]}`,
                }}
              >
                <span style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[800])}>
                  Hoa hồng bán gói đầu tư HTKD
                </span>
                <div className="mt-2 d-flex">
                  <div className="flex-grow-1 w-100 mb-2">
                    <div>
                      {UIHelper.buildFormLabel('Tỷ lệ hoa hồng')}
                      <KTFormInput
                        name="commissionRateGroup"
                        value={commissionRateGroup}
                        unit="%"
                        type={KTFormInputType.number}
                        onChange={(value) => {
                          setCommissionRateGroup(value);
                        }}
                        disabled={!editMode}
                      />
                    </div>
                  </div>
                  <div className="flex-grow-1 w-100"></div>
                </div>
              </div>

              {/* hoa hong ban nhuong quyen */}
              <div
                className="pt-4 pb-2"
                style={{
                  borderBottom: `1px dashed ${AppColors.gray[300]}`,
                }}
              >
                <span style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[800])}>
                  Hoa hồng bán nhượng quyền
                </span>
                <div className="mt-2 d-flex">
                  <div className="mb-2 flex-grow-1 w-100">
                    <div>
                      {UIHelper.buildFormLabel('Tỷ lệ hoa hồng')}
                      <KTFormInput
                        name="commissionRateSale"
                        value={commissionRateSale}
                        unit="%"
                        onChange={(value) => {
                          setCommissionRateSale(value);
                        }}
                        disabled={!editMode}
                      />
                    </div>
                  </div>
                  <div className="flex-grow-1 w-100"></div>
                </div>
              </div>

              {/* hoa hong ban tru sac */}
              <div
                className="pt-4 pb-2"
                style={{
                  borderBottom: `1px dashed ${AppColors.gray[300]}`,
                }}
              >
                <span style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[800])}>
                  Hoa hồng bán trụ sạc
                </span>
                <div className="mt-2 d-flex">
                  <div className="mb-2 flex-grow-1 w-100">
                    <div>
                      {UIHelper.buildFormLabel('Tỷ lệ hoa hồng')}
                      <KTFormInput
                        name="commissionRateChargePoint"
                        value={commissionRateChargePoint}
                        unit="%"
                        onChange={(value) => {
                          setCommissionRateChargePoint(value);
                        }}
                        disabled={!editMode}
                      />
                    </div>
                  </div>
                  <div className="flex-grow-1 w-100"></div>
                </div>
              </div>

              {/* hoa hong gioi thieu mat bang */}
              <div className="py-4">
                <span style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[800])}>
                  Hoa hồng giới thiệu mặt bằng
                </span>
                <div className="mt-2 d-flex flex-column gap-3 mb-4">
                  {commissionGrounds?.map((item, index) => (
                    <div
                      key={index}
                      className={`d-flex w-100 align-items-end gap-3`}
                    >
                      <div className='flex-grow-1'>
                        {UIHelper.buildFormLabel('Loại mặt bằng')}
                        <KTFormInput
                          name={`commissionGroundName${index}`}
                          value={item.name}
                          onChange={(value) => {
                            const newCommissionGrounds = [...commissionGrounds];
                            newCommissionGrounds[index].name = value;
                            setCommissionGrounds(newCommissionGrounds);
                          }}
                          placeholder="Nhập tên loại mặt bằng"
                          disabled={!editMode}
                        />
                      </div>
                      {!item?.show ? (
                        <div style={{ width: '200px' }}>
                          {UIHelper.buildFormLabel('Mức hoa hồng')}
                          <KTFormInput
                            name={`commissionGroundValue${index}`}
                            value={item.value}
                            unit="VNĐ"
                            type={KTFormInputType.currency}
                            onChange={(value) => {
                              const newCommissionGrounds = [...commissionGrounds];
                              newCommissionGrounds[index].value = value;
                              setCommissionGrounds(newCommissionGrounds);
                            }}
                            isValid={item.value > 0}
                            disabled={!editMode}
                          />
                        </div>
                      ) : (
                        <>
                          <div style={{ width: '200px' }}>
                            {UIHelper.buildFormLabel('Mức hoa hồng ô tô')}
                            <KTFormInput
                              name={'commissionGroundValueByCar' + index}
                              value={item.car}
                              unit="VNĐ"
                              type={KTFormInputType.currency}
                              onChange={(value) => {
                                const newCommissionGrounds = [...commissionGrounds];
                                newCommissionGrounds[index].car = value;
                                setCommissionGrounds(newCommissionGrounds);
                              }}
                              isValid={item.car > 0}
                              disabled={!editMode}
                            />
                          </div>
                          <div style={{ width: '200px' }}>
                            {UIHelper.buildFormLabel('Mức hoa hồng xe máy')}
                            <KTFormInput
                              name={'commissionGroundValueByBike' + index}
                              value={item.bike}
                              unit="VNĐ"
                              type={KTFormInputType.currency}
                              onChange={(value) => {
                                const newCommissionGrounds = [...commissionGrounds];
                                newCommissionGrounds[index].bike = value;
                                setCommissionGrounds(newCommissionGrounds);
                              }}
                              isValid={item.bike > 0}
                              disabled={!editMode}
                            />
                          </div>
                        </>
                      )}

                      <div style={{ width: '80px' }}>
                        {index === 0
                          ? <div className='d-flex gap-1'>
                            {UIHelper.buildFormLabel('Thao tác', false, false)}
                            <KTTooltip
                              text={`<div><span>Bật/tắt theo 2 loại phương tiện ô tô/xe máy</span></div>`}
                              textHeader="Hoa hồng theo phương tiện"
                              isHtmlContent
                            >
                              <i className="fa-regular fa-circle-info" style={{ color: AppColors.info }} />
                            </KTTooltip>
                          </div>
                          : UIHelper.buildFormLabel('')}
                        <div className='d-flex gap-2 align-items-center'>
                          {UIHelper.buildToggleSwitch(
                            item.show,
                            () => {
                              if (!editMode) return;
                              setCommissionGrounds(prev => {
                                const newCommissionGrounds = [...prev];
                                if (newCommissionGrounds[index]) {
                                  newCommissionGrounds[index].show = !prev[index].show;
                                }
                                return newCommissionGrounds;
                              });
                            }
                          )}
                          <span
                            className="btn btn-sm btn-clean btn-icon p-0"
                            onClick={() => {
                              if (!editMode) return;
                              const newCommissionGrounds = [...commissionGrounds];
                              newCommissionGrounds.splice(index, 1);
                              setCommissionGrounds(newCommissionGrounds);
                            }}>
                            <i className="fa-regular fa-trash-can cursor-pointer" style={{ color: AppColors.gray[600] }} />
                          </span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="d-flex">
                  {UIHelper.buildNegativeButton(
                    'Thêm',
                    () => {
                      if (!editMode) return;
                      setCommissionGrounds([...commissionGrounds, { name: '', value: 0, bike: 0, car: 0, show: 0 }]);
                    },
                    <i className="fa-regular fa-plus" />
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </KT01BaseLayout>
  );
}

export default AgencyConfigCommissionScreen;
